import React, { Component } from "react";
import { Button, DropdownButton, Glyphicon, MenuItem} from "react-bootstrap";
import "../../css/exercise/DropdownExerciseCategories.css";

export default class DropdownExerciseCategories extends React.Component {

    constructor(props) {
        super(props);
        this.state = { category: 'Select' };
    }

    componentWillReceiveProps (nextProps) {
        var id    = parseInt(nextProps.id);
        var category = nextProps.category;

        this.setState({
            id:    id,
            category: category,
        });
    }

    onSelect(event) {
        var id       = event[0];
        var category = event[1];
        this.setState({
            id:    id,
            category: category
        });

        this.props.getExerciseCategory(id, category); // update id in parent
    }

    render() {
        return (
            <DropdownButton id="Category"
                            onSelect  = {(event) => this.onSelect(event)}
                            title     = {this.state.category}
                            className = "dropdownCategory"
                            //className="dropdownMeasureCaret"
                        >
                    <MenuItem divider />
                    <MenuItem eventKey={["100", "Foam Roll"]} name="Sets"><span className="glyphicon glyphicon-folder-open"/> &nbsp; Foam Roll</MenuItem>

                        <MenuItem eventKey={["125", "Upper Body"]} className="sectionSpacing">Upper Body</MenuItem>
                        <MenuItem eventKey={["150", "Lower Body"]} className="sectionSpacing">Lower Body</MenuItem>

                    <MenuItem divider />
                    <MenuItem eventKey={["200", "Prep (Dynamic Warm Up)"]}><span className="glyphicon glyphicon-folder-open"/> &nbsp; Prep (Dynamic Warm Up)</MenuItem>

                        <MenuItem eventKey={["225", "Combination"]} className="sectionSpacing">Combination</MenuItem>
                        <MenuItem eventKey={["250", "Upper Body"]} className="sectionSpacing">Upper Body</MenuItem>
                        <MenuItem eventKey={["275", "Lower Body"]} className="sectionSpacing">Lower Body</MenuItem>

                    <MenuItem divider />
                    <MenuItem eventKey={["300", "Correct (Rehab/Prehab/Correctives)"]}><span className="glyphicon glyphicon-folder-open"/> &nbsp; Correct (Rehab/Prehab/Correctives)</MenuItem>

                        <MenuItem className="sectionSpacing" eventKey={["325", "Upper Body"]}>Upper Body</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["330", "Shoulder"]}>Shoulder</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["335", "Elbow"]}>Elbow</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["340", "Wrist"]}>Wrist</MenuItem>

                        <MenuItem className="sectionSpacing" eventKey={["350", "Lower Body"]}>Lower Body</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["355", "Hip and Thigh"]}>Hip and Thigh</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["360", "Knee"]}>Knee</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["365", "Ankle"]}>Ankle</MenuItem>

                        <MenuItem className="sectionSpacing" eventKey={["375", "Spine"]}>Spine</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["380", "Cervical"]}>Cervical</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["385", "Thoracic"]}>Thoracic</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["388", "Lumbar"]}>Lumbar</MenuItem>

                        <MenuItem className="sectionSpacing" eventKey={["390", "Diaphragm and Posture"]}>Diaphragm and Posture</MenuItem>
                        <MenuItem className="sectionSpacing" eventKey={["395", "Combinations"]}>Combinations</MenuItem>

                    <MenuItem divider />
                    <MenuItem eventKey={["400", "SLATE (Speed, Landing, Agility, Tempo, Explosion)"]}><span className="glyphicon glyphicon-folder-open"/> &nbsp; SLATE (Speed, Landing, Agility, Tempo, Explosion)</MenuItem>

                        <MenuItem className="sectionSpacing" eventKey={["425", "Core Elasticity"]}>Core Elasticity</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["430", "Vertical"]}>Vertical</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["431", "Catch"]}>Catch</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["432", "Slam"]}>Slam</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["433", "Throw"]}>Throw</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["434", "Combination"]}>Combination</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["440", "Rotational"]}>Rotational</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["441", "Catch"]}>Catch</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["442", "Slam"]}>Slam</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["443", "Throw"]}>Throw</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["443", "Combination"]}>Combination</MenuItem>

                        <MenuItem className="sectionSpacing" eventKey={["450", "Lower Body Elasticity"]}>Lower Body Elasticity</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["455", "Bilateral"]}>Bilateral</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["456", "Linear"]}>Linear</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["457", "Lateral and Rotational"]}>Lateral and Rotational</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["465", "Unilateral"]}>Unilateral</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["466", "Linear"]}>Linear</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["467", "Lateral and Rotational"]}>Lateral and Rotational</MenuItem>

                        <MenuItem className="sectionSpacing" eventKey={["475", "Closed Chain Agility"]}>Closed Chain Agility</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["480", "Linear"]}>Linear</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["481", "Acceleration and Sprint"]}>Acceleration and Sprint</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["482", "Sled"]}>Sled</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["483", "Ladders"]}>Ladders</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["484", "Slideboard"]}>Slideboard</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["485", "Jump"]}>Jump</MenuItem>

                        <MenuItem className="sectionSpacing2" eventKey={["488", "Lateral and Combination"]}>Lateral and Combination</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["489", "Acceleration and Sprint"]}>Acceleration and Sprint</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["490", "Sled"]}>Sled</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["491", "Ladders"]}>Ladders</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["492", "Slideboard"]}>Slideboard</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["493", "Jump"]}>Jump</MenuItem>

                        <MenuItem className="sectionSpacing" eventKey={["495", "Open Chain Agility"]}>Open Chain Agility</MenuItem>

                    <MenuItem divider />
                    <MenuItem eventKey={["500", "Strength"]}><span className="glyphicon glyphicon-folder-open"/> &nbsp; Strength</MenuItem>

                        <MenuItem className="sectionSpacing" eventKey={["525", "Upper Body Strength"]}>Upper Body Strength</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["530", "Bilateral Upper Body Push"]}>Bilateral Upper Body Push</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["531", "Horizontal"]}>Horizontal</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["532", "Vertical"]}>Vertical</MenuItem>

                        <MenuItem className="sectionSpacing2" eventKey={["535", "Bilateral Upper Body Pull"]}>Bilateral Upper Body Pull</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["536", "Horizontal"]}>Horizontal</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["537", "Vertical"]}>Vertical</MenuItem>

                        <MenuItem className="sectionSpacing2" eventKey={["540", "Unilateral Upper Body Push"]}>Unilateral Upper Body Push</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["541", "Horizontal"]}>Horizontal</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["542", "Vertical"]}>Vertical</MenuItem>

                        <MenuItem className="sectionSpacing2" eventKey={["545", "Unilateral Upper Body Pull"]}>Unilateral Upper Body Pull</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["546", "Horizontal"]}>Horizontal</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["547", "Vertical"]}>Vertical</MenuItem>

                        <MenuItem className="sectionSpacing2" eventKey={["550", "Arms"]}>Arms</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["551", "Biceps"]}>Biceps</MenuItem>
                        <MenuItem className="sectionSpacing3" eventKey={["552", "Triceps"]}>Triceps</MenuItem>

                        <MenuItem className="sectionSpacing2" eventKey={["555", "Combinations"]}>Combinations</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["560", "Forearms"]}>Forearms</MenuItem>

                    <MenuItem divider />
                    <MenuItem eventKey={["575", "Lower Body Strength"]}><span className="glyphicon glyphicon-folder-open"/> &nbsp; Lower Body Strength</MenuItem>
                        <MenuItem className="sectionSpacing" eventKey={["580", "Bilateral Lower Body Push"]}>Bilateral Lower Body Push</MenuItem>
                        <MenuItem className="sectionSpacing" eventKey={["590", "Bilateral Lower Body Pull"]}>Bilateral Lower Body Pull</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["591", "Vertical Tibia"]}>Vertical Tibia</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["592", "Straight Leg"]}>Straight Leg</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["593", "Bent Leg (Curl)"]}>Bent Leg (Curl)</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["594", "Bent Legged (Hyperextension)"]}>Bent Legged (Hyperextension)</MenuItem>

                        <MenuItem className="sectionSpacing" eventKey={["600", "Unilateral Lower Body Push"]}>Unilateral Lower Body Push</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["601", "Vertical Supported"]}>Vertical Supported</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["602", "Horizontal Supported"]}>Horizontal Supported</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["603", "Unsupported"]}>Unsupported</MenuItem>

                        <MenuItem className="sectionSpacing" eventKey={["610", "Unilateral Lower Body Pull"]}>Unilateral Lower Body Pull</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["611", "Vertical Tibia"]}>Vertical Tibia</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["612", "Straight Leg"]}>Straight Leg</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["613", "Bent Leg (Curl)"]}>Bent Leg (Curl)</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["614", "Bent Legged (Hyperextension)"]}>Bent Legged (Hyperextension)</MenuItem>

                        <MenuItem className="sectionSpacing" eventKey={["620", "Upper/Lower body Strength Combination"]}>Upper/Lower body Strength Combination</MenuItem>

                    <MenuItem divider />
                    <MenuItem eventKey={["625", "Core Stability"]}><span className="glyphicon glyphicon-folder-open"/> &nbsp; Core Stability</MenuItem>
                        <MenuItem className="sectionSpacing" eventKey={["635", "Transverse (Anti-Rotation)"]}>Transverse (Anti-Rotation)</MenuItem>

                        <MenuItem className="sectionSpacing2" eventKey={["636", "Lift or Chop"]}>Lift or Chop</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["637", "Pushouts"]}>Pushouts</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["638", "Landmine"]}>Landmine</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["641", "MedBall"]}>MedBall</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["639", "Keiser Push Pull"]}>Keiser Push Pull</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["640", "Pull and Press Cable Bar"]}>Pull and Press Cable Bar</MenuItem>

                        <MenuItem className="sectionSpacing" eventKey={["730", "Transverse (Rotational)"]}>Transverse (Rotational)</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["731", "Lift or Chop"]}>Lift or Chop</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["732", "Landmine"]}>Landmine</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["733", "MedBall"]}>MedBall</MenuItem>

                        <MenuItem className="sectionSpacing" eventKey={["645", "Sagittal (Anti-Extension)"]}>Sagittal (Anti-Extension)</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["646", "Rollouts"]}>Rollouts</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["647", "Handle"]}>Handle</MenuItem>

                        <MenuItem className="sectionSpacing" eventKey={["660", "Sagittal (Flexion Extension)"]}>Sagittal (Flexion Extension)</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["661", "Combinations"]}>Combinations</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["662", "Sequencing (mobility)"]}>Sequencing (mobility)</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["663", "Anti-Lateral Flexion"]}>Anti-Lateral Flexion</MenuItem>
                        <MenuItem className="sectionSpacing2" eventKey={["664", "Lateral Flexion"]}>Lateral Flexion</MenuItem>

                    <MenuItem divider />
                    <MenuItem eventKey={["675", "Olympic and Weightlifting"]}><span className="glyphicon glyphicon-folder-open"/> &nbsp; Olympic and Weightlifting</MenuItem>
                        <MenuItem className="sectionSpacing" eventKey={["680", "Bilateral Push"]}>Bilateral Push</MenuItem>
                        <MenuItem className="sectionSpacing" eventKey={["685", "Bilateral Pull"]}>Bilateral Pull</MenuItem>
                        <MenuItem className="sectionSpacing" eventKey={["690", "Bilateral Combination"]}>Bilateral Combination</MenuItem>
                        <MenuItem className="sectionSpacing" eventKey={["695", "Unilateral Push"]}>Unilateral Push</MenuItem>
                        <MenuItem className="sectionSpacing" eventKey={["700", "Unilateral Pull"]}>Unilateral Pull</MenuItem>
                        <MenuItem className="sectionSpacing" eventKey={["710", "Unilateral Combination"]}>Unilateral Combination</MenuItem>

                    <MenuItem divider />
                    <MenuItem eventKey={["1000", "Miscellaneous"]}><span className="glyphicon glyphicon-folder-open"/> &nbsp; Miscellaneous</MenuItem>
             </DropdownButton>
         );
     }

}



// WEBPACK FOOTER //
// ./src/components/exercise/DropdownExerciseCategories.js